document.addEventListener('DOMContentLoaded', function() {
    const openMenuMobile = document.getElementById('open-menu-mobile');
    const menuMobile = document.getElementById('menu-mobile');

    if(openMenuMobile){
        openMenuMobile.addEventListener('click', function() {
            menuMobile.classList.toggle('open');
        });
        
        openMenuMobile.addEventListener('click', function() {
            openMenuMobile.classList.toggle('active');
        });
    }

    window.addEventListener('scroll', function() {
        var header = document.querySelector('.container-items-menu');
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    });
});
